const portfolioData = [
  {
    id: "web-design",
    title: "Corporate Web Design & Development",
    category: "Web Design",
    desc: "A modern, conversion-driven website built to express brand vision and generate business leads.",
    images: [
      "/portfolio/web1.webp",
      "/portfolio/web2.webp",
      "/portfolio/web3.webp"
    ],
    challenge:
      "The business needed a website that looked modern, conveyed trust, loaded fast, and encouraged visitors to take action.",
    solution:
      "We redesigned the website from scratch with a new layout, optimized content structure, stronger brand visuals, mobile responsiveness, and SEO-focused messaging.",
    results: [
      "78% increase in time spent on pages",
      "42% increase in qualified leads",
      "Site loading time improved from 4.3s to 1.9s",
      "Average bounce rate dropped from 63% to 29%"
    ],
    tools: ["Hosting", "Domains", "UI Frameworks"]
  },

  {
    id: "brand-identity",
    title: "Brand Identity & Logo System",
    category: "Branding & Identity",
    desc: "A polished visual identity system that communicates personality, structure, and brand consistency.",
    images: [
      "/portfolio/branding1.webp",
      "/portfolio/branding2.webp"
    ],
    challenge:
      "The existing brand lacked consistency and visual positioning, and was not translating well across digital platforms.",
    solution:
      "We developed a complete brand system including logo guides, typography, color theory, visual rules, and scalable design assets.",
    results: [
      "Consistent visual expression across all channels",
      "Brand recognition improved within 30 days",
      "Social engagement rose by 51%",
      "Client reported increased perceived company credibility"
    ],
    tools: ["Logo Generators", "Brand Guidelines", "Typography Tools"]
  },

  {
    id: "media-production",
    title: "Short-Form Media & Brand Stories",
    category: "Media Production",
    desc: "Engaging brand video reels and short-form content for digital platforms.",
    images: [
      "/portfolio/media1.webp",
      "/portfolio/media2.webp"
    ],
    challenge:
      "The client needed recurring content that could drive engagement and attention on social platforms, without losing storytelling quality.",
    solution:
      "We produced multiple short-form video assets with strong visual direction, audio alignment, transitions, and brand cues to make content memorable.",
    results: [
      "Average video views increased by 325%",
      "TikTok & Reels engagement improved by 65%",
      "Consistent posting pipeline established",
      "Content improved brand recall and shareability"
    ],
    tools: ["Video Editors", "Social Schedulers", "Audio Tools"]
  },

  {
    id: "digital-strategy",
    title: "Digital Marketing & Conversion Strategy",
    category: "Digital Strategy",
    desc: "Campaign restructuring, message positioning, and funnel optimization for paid and organic results.",
    images: [
      "/portfolio/web-logo.png"
    ],
    challenge:
      "Marketing campaigns were not converting efficiently. Cost per result was high and messaging was inconsistent.",
    solution:
      "We analyzed the customer's buyer journey and rebuilt campaigns with stronger hooks, audience segmentation, custom funnel restructuring, and optimized landing pages.",
    results: [
      "Cost per lead reduced by 43%",
      "Audience retention improved across ads",
      "More qualified leads reached the funnel",
      "Campaign metrics improved month over month"
    ],
    tools: ["Funnels", "Email Automation", "Analytics Platforms"]
  },

  {
    id: "uiux-design",
    title: "UI/UX App Design & Experience Workflow",
    category: "Product UI & Interaction",
    desc: "A full-scale user interface design for a digital service platform, focusing on usability and clarity.",
    images: [
      "/portfolio/uiux.jpg"
    ],
    challenge:
      "The client needed an interface that reduced confusion, improved user flow, and increased task completion rates.",
    solution:
      "We designed a structured sitemap, user flow diagrams, interactive prototype screens, and visual components aligned with modern UX principles.",
    results: [
      "User completion rate increased from 64% to 91%",
      "Customer support queries reduced by 37%",
      "Improved accessibility and visual simplicity",
      "Stakeholders approved prototype on first round"
    ],
    tools: ["Prototyping Tools", "Wireframe Software", "UI Libraries"]
  }
];

export default portfolioData;
